import { Component, OnInit, ElementRef, AfterViewInit, Input } from '@angular/core';

import { ContaService } from '../../../../../shared/services/conta/conta.service';
import { LocalStorageService } from '../../../../../shared/services/local-storage/local-storage.service';

import * as moment from 'moment';
import * as CountUp from 'countup.js';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-faturamento',
  templateUrl: './faturamento.component.html',
  styleUrls: ['./faturamento.component.scss']
})
export class FaturamentoComponent implements OnInit, AfterViewInit {
  public table: any = null;
  public loaded = false;

  public error = false;

  public faturamentos: any[] = [];

  public ciclo: any = { inicio: '', fim: '' };

  public qtdBoletos = 0;
  public qtdTransacoes = 0;

  public porcentagemBoletos = 15;
  public porcentagemTransacoes = 15;

  public valorTotal: any = { reais: 200, centavos: 15 };

  public dataProximoPagamento: any;
  public valorProximoPagamento: any;

  public faturamento: any = null;

  public showModalError = false;
  public errorMessage = '';

  public cartaoCadastrado = null;

  public brands: any = [
    { name: 'JCB', className: 'jcb', displayName: 'JCB' },
    { name: 'Elo', className: 'elo', displayName: 'Elo' },
    { name: 'Amex', className: 'amex', displayName: 'American Express' },
    { name: 'Visa', className: 'visa', displayName: 'Visa' },
    { name: 'Aura', className: 'aura', displayName: 'Aura' },
    { name: 'Diners', className: 'diners', displayName: 'Diners' },
    { name: 'Master', className: 'master', displayName: 'Mastercard' },
    { name: 'Discover', className: 'discover', displayName: 'Discover' },
  ];

   @Input() public contaId = null;

  constructor(
    private router: Router,
    private elRef: ElementRef,
    private contaService: ContaService,
    private localStorage: LocalStorageService,
  ) {
    moment.locale('pt-br');
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.obterFaturamento();
  }

  showData() {
    const self = this;
    this.table = $('#master-detail-table-faturamento').DataTable({
      scrollX: true,
      destroy: true,
      paging: true,
      pagingType: 'numbers',
      lengthChange: false,
      searching: false,
      processing: false,
      info: true,
      data: self.faturamentos,
      language: {
        emptyTable: ' ',
        info: '_START_ - _END_ de _MAX_',
      },
      initComplete: function() {
        self.loaded = true;

        if (self.faturamentos && self.faturamentos.length === 0) {
          $('#master-detail-table-faturamento_info').html('0 - 0 de 0');
        }
      },
      columns: [
        { title: 'ID', data: 'Id' },
      ],
    });
  }

  getFaturamentos() {
    this.showData();
  }

  getCiclePercent(data: any) {
    if (!data) { return;}
    const start = moment(data.DataInicioCiclo, 'YYYY-MM-DD');
    const end = moment(data.DataFimCiclo, 'YYYY-MM-DD');
    const today = moment(moment(), 'YYYY-MM-DD');

    const a = moment.duration(start.diff(end)).asDays() * (-1);
    const b = 100;
    const c = moment.duration(start.diff(today)).asDays() * (-1);

    const x = (b * c) / a;

    this.setCicle(x);
  }

  setCicle(percent: any) {
    const cicle = this.elRef.nativeElement.querySelector('#cicle');
    const r = cicle.getAttribute('r');
    const c = Math.PI * (r * 2);

    if (percent < 0) { percent = 0; }
    if (percent > 100) { percent = 100; }

    const pct = ((100 - percent) / 100) * c;

    cicle.style.strokeDashoffset = pct;
  }

  obterFaturamento() {
    const user = this.localStorage.get('login');
    const userId = this.contaId ? this.contaId : user && user.PersonId ? user.PersonId : null;

    if (!userId) {
      return;
    }

    this.contaService.obterFaturamentoPorPessoaId(userId).subscribe((data: any) => {
      this.faturamento = data;

      this.valorProximoPagamento = this.faturamento &&
                                   this.faturamento.Pagamentos &&
                                   this.faturamento.Pagamentos.length > 0 &&
                                   this.faturamento.Pagamentos[0].Valor ?
                                   this.faturamento.Pagamentos[0].Valor :
                                   null;

      this.dataProximoPagamento = this.faturamento &&
                                   this.faturamento.Pagamentos &&
                                   this.faturamento.Pagamentos.length > 0 &&
                                   this.faturamento.Pagamentos[0].ProximoPagamento ?
                                   this.faturamento.Pagamentos[0].ProximoPagamento :
                                   null;


      this.cartaoCadastrado = this.faturamento &&
                              this.faturamento.Pagamentos &&
                              this.faturamento.Pagamentos.length > 0 &&
                              this.faturamento.Pagamentos[0].Cartao ?
                              this.faturamento.Pagamentos[0].Cartao :
                              null;

      const assinaturaTransacoes = this.faturamento.Assinaturas.find((assinatura: any) => {
        return assinatura.TipoAssinatura.indexOf('Transacoes') > -1;
      });

      if (this.valorProximoPagamento) {
        this.valorProximoPagamento = this.valorProximoPagamento.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
      }

      if (this.dataProximoPagamento) {
        this.dataProximoPagamento = moment(this.dataProximoPagamento).format('DD/MM/YYYY');
      }

      if (assinaturaTransacoes) {
        const countUp = new CountUp.CountUp('qtd-transacoes', assinaturaTransacoes.QuantidadeApurada);
        countUp.start();
      }

      if (assinaturaTransacoes && assinaturaTransacoes.DataInicioCiclo && assinaturaTransacoes.DataFimCiclo) {
        this.ciclo = {
          inicio: moment(assinaturaTransacoes.DataInicioCiclo).format('D MMM'),
          fim: moment(assinaturaTransacoes.DataFimCiclo).format('D MMM'),
        };

      }

      this.getCiclePercent(assinaturaTransacoes);

      this.loaded = true;
      this.error = false;
    }, (err) => {
      console.error(err);

      this.error = true;

      this.showModalError = true;
      this.errorMessage = err &&
                          err.error &&
                          err.error.ModelState &&
                          err.error.ModelState.Erros &&
                          err.error.ModelState.Erros.length > 0 ?
                          err.error.ModelState.Erros[0] :
                          'Não foi possível obter os dados. Tente novamente mais tarde.';
    });
  }

  adicionarCartao() {
    if (
      this.faturamento &&
      this.faturamento.Assinaturas &&
      this.faturamento.Assinaturas.length > 0 &&
      this.faturamento.Assinaturas[0].AssinaturaPessoaId
    ) {
      const user = this.localStorage.get('login');
      const userId = this.contaId ? this.contaId : user && user.PersonId ? user.PersonId : null;

      const obj = {
        PessoaId: userId,
        AssinaturaPessoaId: this.faturamento.Assinaturas[0].AssinaturaPessoaId
      };

      this.contaService.vincularCartao(obj).subscribe((data: any) => {
        if (data) {
          this.router.navigate(['/checkout'], { queryParams: { tokenId: data.TokenId } });
        }
      }, (err) => {
        console.error(err);

        this.showModalError = true;
        this.errorMessage = err &&
                            err.error &&
                            err.error.ModelState &&
                            err.error.ModelState.Erros &&
                            err.error.ModelState.Erros.length > 0 ?
                            err.error.ModelState.Erros[0] :
                            'Não foi possível obter os dados. Tente novamente mais tarde.';
      });
    }
  }

  alterarCartao() {
    const cartao = this.faturamento &&
                   this.faturamento.Pagamentos &&
                   this.faturamento.Pagamentos.length > 0 &&
                   this.faturamento.Pagamentos[0].Cartao ?
                   this.faturamento.Pagamentos[0].Cartao :
                   null;

    if (cartao) {
      this.router.navigate(['/checkout'], { queryParams: { vendaId: cartao.VendaPagueLaId } });
    }
  }

  eventClose() {
    this.errorMessage = '';
    this.showModalError = false;
  }

  obterClasseBandeiraCartao(brandCreditCard) {
    let className = null;
    this.brands.forEach((brand) => {
      if (brand.name === brandCreditCard) {
        className =  brand.className;
      }
    });
    return className;
  }

  resolverProblema(problema: any) {
    if (!problema.VendaPagueLaId) {
      this.adicionarCartao();
    } else {
      this.router.navigate(['/checkout'], { queryParams: { vendaId: problema.VendaPagueLaId } });
    }
  }

  isProvisao() {
    return this.faturamento &&
           this.faturamento.Pagamentos &&
           this.faturamento.Pagamentos.length > 0 ?
           this.faturamento.Pagamentos[0].Provisao :
           false;
  }

  isCartao() {
    return !!(this.faturamento &&
      this.faturamento.Pagamentos &&
      this.faturamento.Pagamentos.length > 0 &&
      this.faturamento.Pagamentos[0].Cartao);
  }

  obterDescricao() {
    return this.faturamento &&
           this.faturamento.Pagamentos &&
           this.faturamento.Pagamentos.length > 0 ?
           this.faturamento.Pagamentos[0].Descricao :
           false;
  }
}
